import { render, staticRenderFns } from "./tablePtenAgent.vue?vue&type=template&id=7d75395b&scoped=true"
import script from "./tablePtenAgent.vue?vue&type=script&lang=js"
export * from "./tablePtenAgent.vue?vue&type=script&lang=js"
import style0 from "./tablePtenAgent.vue?vue&type=style&index=0&id=7d75395b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d75395b",
  null
  
)

export default component.exports